import { pickIndexSectionBackgroundProps } from '@/components/page-sections/index-section-utils';
import { readString } from '@/lib/prop-utils';
import type { CaseResultIndexProps } from './definition';

export function readCaseResultIndexProps(props: CaseResultIndexProps) {
  const rawProps = props as Record<string, unknown>;
  const pinnedHeading = readString(props.pinnedHeading);
  const pinnedDescription = readString(props.pinnedDescription);

  return {
    ...props,
    pinnedHeading: pinnedHeading ?? '',
    pinnedDescription: pinnedDescription ?? '',
    showFilters: props.showFilters ?? true,
    backgroundProps: pickIndexSectionBackgroundProps(rawProps),
  };
}
